/**
 * Created by Ivan on 07.07.2026
 */

const StickersBookSeasonWindow = Prefab.createWindow("stickers_book_season_window", "stickers_book_season_window_prefab_json", {
    bundles: () => [SeasonCollectionsHelper.getSeasonBundleName(cleverapps.stickersBook.season)].filter((name) => bundles[name])
});
